// creates array of arrays of num elements, num should be positive
// groupArrayItems([1,2,3,4,5], 2) => [[1,2], [3,4], 5]
export function groupArrayItems<T>(arr: T[], num: number): T[][] {
  if (num < 1) return []
  const result: T[][] = []
  let currentGroup = []
  let counter = 0
  while (counter < arr.length) {
    if (counter % num === 0) {
      if (currentGroup && counter) {
        result.push(currentGroup)
      }
      currentGroup = []
    }
    currentGroup.push(arr[counter])
    counter++
  }
  if (currentGroup.length) {
    result.push(currentGroup)
  }
  return result
}
